// ASF Suchfunktions-Umbau (Sept. 2026):
// 1) wählt im Suchmodal den Reiter "Rezepte & Stories" (type=article) automatisch
//    vor, wenn der Suchbegriff "rezept" enthält.
// 2) markiert den per Klick aktivierten Reiter mit der Klasse "is-active-tab" und
//    die Tableiste mit "js-tab-selected", damit die CSS-Regel in
//    search-drawer.liquid den Balken darunter zeichnen kann (Desktop). Solange
//    noch nicht geklickt wurde, übernimmt reines CSS (:first-of-type) den Balken
//    unter dem ersten Reiter ("Produkte") - das erscheint dadurch sofort beim
//    Rendern, ohne auf JavaScript-Timing angewiesen zu sein.
// 3) sendet GA4-Events (via GTM dataLayer) search_tab_click und search_recipe_click.
// 4) Ergänzung 22.09.2026: wählt den neuen "Hilfe"-Reiter (type=help) automatisch
//    vor, wenn der Suchbegriff ein Support-Wort enthält (zahlung, versand, ...).
//    Der Reiter existiert nur, wenn snippets/asf-search-help-content.liquid für
//    den Suchbegriff etwas ausgibt - siehe sections/search-drawer.liquid.
//    Hilfe hat Vorrang vor Rezepte, falls ein Begriff (theoretisch) beides träfe.
// Siehe Projekt-Doc "Umbau_Suchfunktion_Briefing.md".
(function () {
  window.dataLayer = window.dataLayer || [];

  function currentSearchTerm(scope) {
    var root = scope || document;
    var input = root.querySelector ? root.querySelector('input[name="q"]') : null;
    if (input && input.value) return input.value;
    var params = new URLSearchParams(window.location.search);
    return params.get('q') || '';
  }

  function markActiveTab(tabLabelButton) {
    var tabItem = tabLabelButton.closest('.predictive-search__tab-item');
    var tabsEl = tabItem && tabItem.closest('.predictive-search__tabs');
    if (!tabItem || !tabsEl) return;

    tabsEl.classList.add('js-tab-selected');
    Array.prototype.forEach.call(tabsEl.querySelectorAll('.predictive-search__tab-item'), function (el) {
      el.classList.toggle('is-active-tab', el === tabItem);
    });
  }

  // --- Tracking: search_tab_click & search_recipe_click -------------------
  document.addEventListener('click', function (event) {
    var recipeLink = event.target.closest('a.predictive-search-result[href*="/blogs/rezept/"]');
    if (recipeLink) {
      window.dataLayer.push({
        event: 'search_recipe_click',
        search_term: currentSearchTerm(recipeLink.closest('form') || document),
        link_url: recipeLink.getAttribute('href')
      });
      return;
    }

    var tabButton = event.target.closest('.predictive-search__tab-label');
    if (tabButton) {
      markActiveTab(tabButton);

      var tabItem = tabButton.closest('.predictive-search__tab-item');
      var tabType = tabItem ? tabItem.getAttribute('data-tab-type') : null;
      window.dataLayer.push({
        event: 'search_tab_click',
        tab: tabType || tabButton.textContent.trim(),
        search_term: currentSearchTerm(tabButton.closest('form') || document)
      });
    }
  }, true);

  // --- Hilfe-Tab vorauswählen, wenn Suchbegriff ein Support-Wort enthält ---
  function tryActivateHelpTab(root, state) {
    var term = currentSearchTerm(root);
    if (!term || term === state.lastHelpTerm) return;

    var tabItem = root.querySelector('[data-tab-type="help"]');
    var button = tabItem && tabItem.querySelector('.predictive-search__tab-label');
    if (button) {
      button.click();
      state.lastHelpTerm = term;
    }
  }

  // --- Rezepte-Tab vorauswählen, wenn Suchbegriff "rezept" enthält --------
  function tryActivateRecipeTab(root, state) {
    var term = currentSearchTerm(root);
    if (!term || term === state.lastTerm) return;
    if (term.toLowerCase().indexOf('rezept') === -1) return;

    var tabItem = root.querySelector('[data-tab-type="article"]');
    var button = tabItem && tabItem.querySelector('.predictive-search__tab-label');
    if (button) {
      button.click();
      state.lastTerm = term;
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('search-drawer').forEach(function (root) {
      var state = { lastTerm: null, lastHelpTerm: null };

      tryActivateRecipeTab(root, state);
      tryActivateHelpTab(root, state);

      // Mehrfach mit kurzer Verzögerung versuchen, falls die x-tabs-Komponente
      // beim ersten Aufruf (DOMContentLoaded) noch nicht vollständig upgraded ist.
      // tryActivateRecipeTab/tryActivateHelpTab sind dank state.lastTerm /
      // state.lastHelpTerm idempotent (klicken pro Suchbegriff höchstens einmal).
      [0, 150, 500].forEach(function (delay) {
        setTimeout(function () {
          tryActivateRecipeTab(root, state);
          tryActivateHelpTab(root, state);
        }, delay);
      });

      var results = root.querySelector('[slot="results"]');
      if (results) {
        new MutationObserver(function () {
          tryActivateRecipeTab(root, state);
          tryActivateHelpTab(root, state);
        }).observe(results, { childList: true, subtree: true });
      }
    });
  });
})();